//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
let d=[[[0,"Breakaway",1,0],[0,"IsPanelFolder",1,0],[0,"OptimizationMethod",1,0],[0,"PanelFile",1,0],[0,"PanelFolder",1,0],[0,"PanelLocation",1,0],[0,"ShowLog",1,0],[0,"SolderMasks",1,0],[0,"TcItemNumber",1,0],[0,"TcItemRevision",1,0],[0,"Thieving",1,0],[0,"UseCurrentWorkPart",1,0],[0,"UseEntityFilter",1,0]],[[["numOutputsParts"],"GetOutputParts",{R_:{outputsParts:""}},0,0],[["outputsParts"],"SetOutputParts",{},1,0],[["numOutputsNames"],"GetOutputNames",{R_:{outputsNames:""}},0,0],[["outputsNames"],"SetOutputNames",{},1,0],[[],"PrepareOdbFolder",{R_:{folderName:''}},0,0],[[],"GetEntityFilter",{R_:{filter:"PcbExchange.EntityFilter"}},0,0],[["filter"],"SetEntityFilter",{},1,0]],[]];
SPLM.PcbExchange.EcadPanelImportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.EcadPanelImportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.EcadPanelImportBuilder.ThievingOptions = Object.freeze({
    "None" : "None", "Curve" : "Curve", "SolidBody" : "SolidBody"});

SPLM.PcbExchange.EcadPanelImportBuilder.OptimizationMethodOptions = Object.freeze({
    "None" : "None", "Pattern" : "Pattern"});

SPLM.PcbExchange.EcadPanelImportBuilder.PanelLocationEnum = Object.freeze({
    "Os" : "Os", "Tc" : "Tc"});

export default SPLM;